import { useParams } from "react-router";
import { motion } from "motion/react";
import { useState } from "react";
import CollaboratorCalendar from "./components/CollaboratorCalendar";
import CollaboratorEvents from "./components/CollaboratorEvents";
import CollaboratorDocuments from "./components/CollaboratorDocuments";
import CollaboratorHeader from "./components/CollaboratorHeader";
import { Tab } from "../../../../components/TabBar";
import CollaboratorTabBar from "./components/CollaboratorTabBar";
import { DocumentType } from "../../../../__generated__/graphql";
import CollaboratorInformations from "./components/CollaboratorInformations";

export default function Collaborator() {
  const { userOrganizationId } = useParams();
  const [selectedTab, setSelectedTab] = useState<Tab | null>(null);

  return (
    <motion.div
      className="flex flex-col gap-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <CollaboratorHeader userOrganizationId={userOrganizationId} />

      <CollaboratorTabBar
        onTabChange={setSelectedTab}
        userOrganizationId={userOrganizationId}
      />

      <motion.div
        key={selectedTab?.label}
        // className="flex flex-col gap-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        {(!selectedTab || selectedTab.value === "information") && (
          <CollaboratorInformations userOrganizationId={userOrganizationId} />
        )}
        {selectedTab?.value === "planning" && (
          <CollaboratorCalendar userOrganizationId={userOrganizationId} />
        )}
        {selectedTab?.value === "events" && (
          <CollaboratorEvents userOrganizationId={userOrganizationId} />
        )}
        {selectedTab?.value === "documents" && (
          <CollaboratorDocuments
            userOrganizationId={userOrganizationId}
            filterByDocumentType={[DocumentType.Other]}
          />
        )}
        {selectedTab?.value === "communication" && (
          <CollaboratorDocuments
            userOrganizationId={userOrganizationId}
            filterByDocumentType={[DocumentType.Communication]}
          />
        )}
        {selectedTab && selectedTab.value === "declarations" && (
          <CollaboratorDocuments
            userOrganizationId={userOrganizationId}
            filterByDocumentType={[
              DocumentType.DeclarationSacd,
              DocumentType.FicheDePaie,
            ]}
          />
        )}
        {selectedTab && selectedTab.value === "gains" && (
          <CollaboratorDocuments
            userOrganizationId={userOrganizationId}
            filterByDocumentType={[DocumentType.Bordereau]}
          />
        )}
        {selectedTab && selectedTab.value === "jour-a-jour" && (
          <CollaboratorDocuments
            userOrganizationId={userOrganizationId}
            filterByDocumentType={[DocumentType.JourAJour]}
          />
        )}
        {selectedTab && selectedTab.value === "scenarios" && (
          <CollaboratorDocuments
            userOrganizationId={userOrganizationId}
            filterByDocumentType={[DocumentType.Scenario]}
          />
        )}
      </motion.div>
    </motion.div>
  );
}
